export const FETCH_TODO_REQUEST = "FETCH_TODO_REQUEST";
export const FETCH_TODO_SUCCESS = "FETCH_TODO_SUCCESS";
export const FETCH_TODO_FAILURE = "FETCH_TODO_FAILURE";

export const FETCH_LANGUAGES_REQUEST = "FETCH_LANGUAGES_REQUEST";
export const FETCH_LANGUAGES_SUCCESS = "FETCH_LANGUAGES_SUCCESS";
export const FETCH_LANGUAGES_FAIL = "FETCH_LANGUAGES_FAIL";

export const FETCH_WORDS_REQUEST = "FETCH_WORDS_REQUEST";
export const FETCH_WORDS_SUCCESS = "FETCH_WORDS_SUCCESS";
export const FETCH_WORDS_FAIL = "FETCH_WORDS_FAIL";

export const ADD_LANGUAGES_REQUEST="ADD_LANGUAGES_REQUEST";

export const EDIT_WORD_REQUEST="EDIT_WORD_REQUEST";
export const EDIT_WORD_SUCCESS="EDIT_WORD_SUCCESS";

export const ADD_WORD_REQUEST="ADD_WORD_REQUEST";